const ActionApiBodyType = [
    {
        value : 'x-www-form-urlencoded',
        text : 'url parameters'
    },
    {
        value : 'form-data',
        text : 'form'
    },
    {
        value : 'raw',
        text : 'json'
    },
]

export default ActionApiBodyType;